import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const ROLE = {
  OPS: 'operation',
  REVIEWER: 'review_committee',
  RECRUITMENT: 'recruitment',
  FINANCE: 'finance',
  ADMINISTRATOR: 'admin',
  SUPERADMIN: 'superadmin',
  ARTIST: 'artist',
};

const state = {
  accessToken: localStorage.getItem('access_token') || '',
  tokenType: localStorage.getItem('token_type') || '',
  expiresIn: localStorage.getItem('expires_in') || 0,
  user: JSON.parse(localStorage.getItem('user')) || '',
  isSuperAdmin: localStorage.getItem('role') === ROLE.SUPERADMIN || false,
  isAdmin: localStorage.getItem('role') === ROLE.ADMINISTRATOR || false,
  isArtist: localStorage.getItem('role') === ROLE.ARTIST || false,
  role: localStorage.getItem('role') || '',
  isOps: localStorage.getItem('role') === ROLE.OPS || false,
  isReviewer: localStorage.getItem('role') === ROLE.REVIEWER || false,
  isRecruitment: localStorage.getItem('role') === ROLE.RECRUITMENT || false,
  isFinance: localStorage.getItem('role') === ROLE.FINANCE || false,
  isUpdateTnc: localStorage.getItem('isUpdateTnc') === 'true' || false,
  roleList: ROLE,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/Auth/index.js